import React, { useEffect } from "react";
import {
  Area,
  AreaChart,
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

function OrderCompareView({ dataLineChart, lables }) {


  return (
    <>
      <ResponsiveContainer width="100%" minHeight={"18rem"}>
        <LineChart
          width={"auto"}
          height={"17.5rem"}
          data={dataLineChart}
          margin={{
            top: 5,
            right: 10,
            left: 0,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" fontSize={"10px"} angle={10} tickMargin={10} />
          <YAxis tickMargin={40} fontSize={"13px"} />
          <Tooltip />

          <Line
            type="monotone"
            name={lables.date1}
            dataKey="value"
            stroke="#3592FB"
            activeDot={{ r: 8 }}
          />
          <Line
            type="monotone"
            name={lables.date2}
            dataKey="value1"
            stroke="rgba(154, 64, 224, 1)"
            activeDot={{ r: 8 }}
          />
          <Line
            type="monotone"
            name={lables.date3}
            dataKey="value2"
            stroke="rgba(255, 152, 0, 1)"
            activeDot={{ r: 8 }}
          />
         
        </LineChart>
      </ResponsiveContainer>
    </>
  );
}

export default OrderCompareView;
